import { getAccounts } from "../api";
import { Account } from "./types";

export async function getMinimalAccountsInfo(): Promise<{
  credit_cards: Account[];
  personal_loans: Account[];
}> {
  const { data } = await getAccounts();
  const mappedPL = data.personal_loans.map((pl) => ({
    ...pl,
    greekable: true,
  }));
  const mappedCC = data.credit_cards.map((cc) => ({
    ...cc,
    greekable: !!cc.links.length,
  }));

  return {
    credit_cards: mappedCC,
    personal_loans: mappedPL,
  };
}
